const clients = "/clients/:clientId";
const users = "/users";
const permissions = "/permissions";
const selectClients = "/clients/select";
const clientLoginSettings = "/login/settings";
const clientInvitations = "/clientInvitations";
const login = "/login";
const log = "log";
const invite = "/invite/:inviteId";
const verifyLoginMethod = `${login}/verify/external`;

const api = {
  select: {
    clients: {
      all: selectClients,
      one: `${selectClients}/:clientId`,
    },
  },
  clientInvitations: {
    invite: `${clientInvitations}/:clientId/invite`,
    one: `${clientInvitations}/:clientInvitationId`,
    all: `${clientInvitations}/:clientId/list`,
    resendInvite: `${clientInvitations}/:clientId/invite/reset`,
    acceptInvite: `${clientInvitations}/:clientInvitationId/accept`,
    declineInvite: `${clientInvitations}/:clientInvitationId/decline`,
    deleteInvite: `${clientInvitations}`,
  },
  password: {
    reset: `${users}/resetPassword`,
    resetEmail: `${users}/resetPassword/email`,
    passwordOptions: `${users}/options`,
  },
  manage: {
    base: clients,
    users: {
      all: users,
      one: `${users}/:userId`,
      current: `${users}/current`,
      roles: `${users}/roles`,
      changePassword: `${users}/:userId/password`,
    },
    permissions: {
      all: permissions,
    },
    clientLogin: {
      settings: clientLoginSettings,
    },
  },
  login: {
    settings: `${login}/settings`,
    byPassword: login,
    verify: {
      external: verifyLoginMethod,
      resend: `${verifyLoginMethod}/resend`,
    },
  },
  invite: {
    validate: `${invite}/validate`,
    register: `${invite}/register`,
    passwordOptions: `${invite}/options`,
  },
  log: {
    clientSelect: `${log}/clientSelect`,
  },
  clientImages: `${clients}/images`,
};

export default api;
